import { useCallback, useState } from 'react';
import { cleanNumeric, formatStringNumber } from './StringHelper';
import { Textbox, TextboxChangeEvent } from './Textbox';
import { Icon } from './Icon';

interface CurrencyTextboxProps {
    value?: number | string;
    onChange: (e: TextboxChangeEvent) => void;
    onBlur?: () => void;
    disabled?: boolean;
    placeholder?: string;
    className?: string;
    id?: string;
    name?: string;
    tabIndex?: number;
    autoComplete?: string;
}

export function CurrencyTextbox(props: CurrencyTextboxProps) {
    const { value, tabIndex, autoComplete, placeholder, disabled, className, id, name, onBlur, onChange } = props;

    const [currencyString, setCurrencyString] = useState(formatStringNumber(value?.toString()) ?? '0.00');

    const handleChange = useCallback(
        (e: TextboxChangeEvent) => {
            const { value } = e.currentTarget;
            const str = cleanNumeric(value);
            setCurrencyString(str);
            onChange({ currentTarget: { value: str } });
        },
        [onChange]
    );

    const handleBlur = useCallback(() => {
        const str = formatStringNumber(value?.toString() ?? '')
        onChange({ currentTarget: { value: str } });
        setCurrencyString(str);
        onBlur && onBlur();
    }, [onBlur, onChange, value]);

    return (
        <div className="input-group grow md:grow-0">
            <span className="input-group-prepend">
                <Icon name="dollar-sign" />
            </span>
            <Textbox
                id={id}
                type="tel"
                disabled={disabled}
                className={className}
                onChange={handleChange}
                value={currencyString}
                name={name}
                onBlur={handleBlur}
                placeholder={placeholder}
                autoComplete={autoComplete}
                tabIndex={tabIndex}
            />
        </div>
    );
}
